import React from 'react';

/**
 * Props:
 * title      string  bold status line
 * subtitle   string  muted line below (e.g. live found count)
 */
const BrandedSpinner = (props) => (
    <div className="fs-miniloader mb-4">
        <div className="fs-miniloader-spinner">
            <div className="fs-miniloader-ring"></div>
            <div className="fs-miniloader-plane">
                <svg width="26" height="26" viewBox="0 0 24 24" fill="currentColor" stroke="none">
                    <path d="M17.8 19.2 16 11l3.5-3.5c1-1 1.5-2.4 1.5-3.5a2.12 2.12 0 0 0-2-2c-1.1 0-2.5.5-3.5 1.5L12 8 3.8 6.2c-.5-.1-.9.1-1.1.5l-.3.5c-.2.5-.1 1 .3 1.3L9 12l-2 3H4l-1 1 3 2 2 3 1-1v-3l3-2 3.5 5.3c.3.4.8.5 1.3.3l.5-.2c.4-.3.6-.7.5-1.2z"/>
                </svg>
            </div>
        </div>
        <div className="fs-miniloader-text">
            <div className="fs-miniloader-title">{props.title}</div>
            <div className="fs-miniloader-sub">{props.subtitle}</div>
        </div>
        <div className="fs-miniloader-bar">
            <div className="fs-miniloader-bar-fill"></div>
        </div>
    </div>
);

export default BrandedSpinner;



// WEBPACK FOOTER //
// ./src/components/common/BrandedSpinner.js